<template>
  <div
  :class="{
    'nav-open': $sidebar.showSidebar,
    'environment-banner-offset': mode != 'production',
    'app-theme--dark': $store.state.theme === 'dark'
  }"
  v-loading.fullscreen.lock="$loading"
  :element-loading-text="$loadingText"
  >
    <notifications
      :duration="1000"
      :close-on-click="true"
      transition-name="notification-list"
      transition-mode="out-in"
    >
      <template slot="body" slot-scope="props">
        <div :class="['vue-notification', props.item.type, 'app-toast']">
          <button
            type="button"
            class="app-toast__close"
            aria-label="Close notification"
            title="Close notification"
            @click.stop="props.close"
          >
            &times;
          </button>
          <div v-if="props.item.title" class="notification-title" v-html="props.item.title"></div>
          <div class="notification-content" v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>
    <notifications
      group="seat-assignment"
      position="top right"
      :duration="1000"
      :close-on-click="true"
      transition-name="notification-list"
      transition-mode="out-in"
    >
      <template slot="body" slot-scope="props">
        <div :class="['vue-notification', props.item.type, 'app-toast']">
          <button
            type="button"
            class="app-toast__close"
            aria-label="Close notification"
            title="Close notification"
            @click.stop="props.close"
          >
            &times;
          </button>
          <div v-if="props.item.title" class="notification-title" v-html="props.item.title"></div>
          <div class="notification-content" v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>
    <router-view name="header"></router-view>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>

    <div
      v-if="mode != 'production'"
      class="environment-banner"
      :class="{ 'environment-banner--login': $route.name === 'Login' }"
    >
      {{  mode.toUpperCase() }}
      <div>FOR TESTING ONLY</div>
    </div>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import 'sweetalert2/dist/sweetalert2.css'
import 'vue-notifyjs/themes/default.css'

export default {
  data() {
    return {
      config: process.env.VUE_APP_TEST,
      mode: process.env.VUE_APP_MODE
    };
  },
  created: function () {}
  }
</script>
<style lang="scss">
  .vue-notifyjs .alert {
    z-index: 99999 !important;
  }

  .app-toast {
    position: relative;
    padding-right: 32px !important;
  }

  .app-toast__close {
    position: absolute;
    top: 6px;
    right: 7px;
    padding: 0 3px;
    border: 0;
    color: inherit;
    background: transparent;
    font: inherit;
    font-size: 18px;
    line-height: 1;
    opacity: 0.85;
    cursor: pointer;
  }

  .app-toast__close:hover,
  .app-toast__close:focus-visible {
    opacity: 1;
  }

  .red-label{
    color: #dc3545 !important;
  }

  .environment-banner-offset {
    --environment-banner-clearance: 80px;
  }

  .environment-banner {
    position: fixed;
    z-index: 999;
    bottom: 0;
    width: 100%;
    height: 50px;
    padding: 10px;
    color: #fff;
    background: red;
    text-align: center;
  }

  .environment-banner--login {
    display: flex;
    height: 34px;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0 12px;
    background: #18394b;
    font-size: 10px;
    letter-spacing: 0.17em;
    line-height: 1;
    text-transform: uppercase;
  }

  .environment-banner--login > div {
    margin-left: 2px;
    padding-left: 12px;
    border-left: 1px solid rgba(255, 255, 255, 0.38);
    line-height: 1;
  }
</style>
